export default __webpack_public_path__ + "static/media/repeat.9ff980e7.png";